import { RequisitionsApi } from '../../../../api/Corporates/Requisitions'
import qs from 'query-string'
import React, { useState } from 'react'
import AddVoucher from '../../../../components/Purchasing/Voucher/AddVoucher/AddVoucher'
import { withRouter } from 'react-router-dom'
import { get } from 'lodash'
import { isEmpty } from 'lodash'
import { pick } from 'lodash'
import useFetchObject from '../../../../elements/Hooks/useFetchObject'
import { VouchersApi } from '../../../../api/Purchase/Vouchers'
import useFetchList from '../../../../elements/Hooks/useFetchList'
import { message } from 'antd'
import useSubmit from '../../../../elements/Hooks/useSubmit'
import DocumentsApi from '../../../../api/Documents'
import useTitle from '../../../../elements/Hooks/useTitle'
import useModalData from '../../../../elements/Hooks/useModalData'

const api = VouchersApi
const docsApi = new DocumentsApi()
const formRef = React.createRef()
AddVoucherCont.propTypes = {}

function AddVoucherCont(props) {
  const key = get(props.match, 'params.key')
  const values = qs.parse(props.location.search)
  const requisitionID = values.requisitionID
  const type = key ? 'edit' : 'new'

  //RequisitionsApi.read(req._key)
  const { object: requisition, setObject: setRequisitions } = useFetchObject(
    () => RequisitionsApi.read(requisitionID),
    false,
    [requisitionID],
    isEmpty(requisitionID)
  )

  const { fetch, fetching, object: voucher, setObject: setVoucher } = useFetchObject(
    () => api.get(key),
    false,
    [key],
    isEmpty(key)
  )
  const { list: actions, fetching: fetchingActions, fetch: fetchActions } = useFetchList(
    () => docsApi.actions('vouchers', voucher.status),
    [voucher.status, isEmpty(voucher.status)]
  )

  const [submittingOperation, submitOperation] = useSubmit(VouchersApi.operation)
  const [updating, updateFunc] = useSubmit(api.update)

  function checkForm() {
    return new Promise((res, rej) => {
      formRef.current.validateFieldsAndScroll((err, values) => {
        if (!err) {
          res(values)
        } else rej(err)
      })
    })
  }

  const [submitting, submitFunc] = useSubmit(api.create)

  async function submit() {
    const values = await checkForm()
    const submitted = await submitFunc(values)
    if (submitted)
      props.history.push({
        pathname: `/purchasing/vouchers/${submitted._key}/update`,
      })
  }

  async function update() {
    const values = await checkForm()
    const voucherDB = await updateFunc({
      ...pick(voucher, ['_key', '_id', '_rev']),
      ...values,
    })
    if (voucherDB) setVoucher(voucherDB)
  }

  const [removing, removeFunc] = useSubmit(api.remove, true)

  async function remove() {
    try {
      const removed = await removeFunc({
        ...pick(voucher, ['_key', '_rev', '_id']),
      })
      props.history.replace({
        pathname: `/purchasing/vouchers/`,
      })

      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
  }

  async function handleActions(operation) {
    let hide = message.loading('', 0)
    switch (operation) {
      case 'remove':
        const removed = await removeFunc({
          ...pick(voucher, ['_key', '_rev', '_id']),
        })
        if (removed)
          props.history.replace({
            pathname: `/purchasing/vouchers/`,
          })
        break
      default:
        const ObjectDB = await submitOperation({
          status: operation,
          ...pick(voucher, ['_key', '_rev', '_id']),
        })
        if (ObjectDB) setVoucher(ObjectDB)
    }
    hide()
  }

  async function onHold() {
    let hide = message.loading('', 0)

    let newPaymentStatus = voucher.paymentStatus

    if (voucher.paymentStatus === 'New') {
      newPaymentStatus = 'Hold'
    }

    if (voucher.paymentStatus === 'Hold') {
      newPaymentStatus = 'New'
    }

    try {
      await VouchersApi.update({
        paymentStatus: newPaymentStatus,
        ...pick(voucher, ['_id', '_key', '_rev']),
      })
      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
    hide()

    fetch()
  }

  // lines

  const { list: lines, fetching: fetchingLines, fetch: fetchLines } = useFetchList(
    () => VouchersApi.getLinesByVouchers(voucher._key),
    [voucher._key],
    isEmpty(voucher._key)
  )
  const {
    visible,
    modalType,
    object: line,
    submitting: submittingLine,
    setSubmitting: setSubmittingLine,
    removing: removingLine,
    remove: removeLine,
    formRef: formRefLine,
    onShow,
    onCancel,
    checkForm: checkFormLine,
  } = useModalData(undefined, undefined, VouchersApi.lines.remove, fetchLines)

  async function updateLine() {
    const newObject = await checkFormLine()
    setSubmittingLine(true)
    try {
      await VouchersApi.lines.update({
        _id: get(line, ['_id']),
        ...newObject,
        voucher: { _id: voucher._id },
      })
      onCancel()
      fetchLines()
      const updatedVoucher = await VouchersApi.get(voucher._key)
      setVoucher(updatedVoucher)
      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
    setSubmittingLine(false)
  }

  async function submitLine() {
    const newObject = await checkFormLine()
    setSubmittingLine(true)
    try {
      await VouchersApi.lines.create({
        ...newObject,
        voucher: { _id: voucher._id },
      })
      onCancel()
      fetchLines()

      const updatedVoucher = await VouchersApi.get(voucher._key)
      setVoucher(updatedVoucher)
      message.success('Success')
    } catch (e) {
      console.error(e)
      message.error(e.errorMessage)
    }
    setSubmittingLine(false)
  }

  useTitle(voucher.code === undefined ? `Create New Voucher` : `${voucher.code} Voucher`)

  const isNew = type === 'new'

  // const isUpdatable = !!(isNew || actions.find(a => a.key === 'update'))
  const isConfirmed = ['Confirmed', 'Approved'].includes(voucher.status)

  return (
    <AddVoucher
      {...{
        key,
        type,
        fetch,
        fetching,
        voucher,
        actions,
        fetchingActions,
        fetchActions,
        setVoucher,
        isConfirmed,
        //
        submitting,
        updating,
        submit,
        removing,
        remove,
        update,
        formRef,
        handleActions,
        onHold,
        // lines
        visible,
        modalType,
        line,
        lines,
        fetchingLines,
        fetchLines,
        submittingLine,
        removingLine,
        removeLine,
        formRefLine,
        onShow,
        onCancel,
        checkFormLine,
        updateLine,
        submitLine,
        requisitionID,
        requisition,
      }}
    />
  )
}

export default withRouter(AddVoucherCont)
